import type { TrainingDocument } from '~/gql/documents/documents'

/** Ce qui se règle d'un document (#326) : son titre, son parcours (vide = tous), s'il est à accepter. */
export type DocumentForm = { title: string, sessionId: string, requiredBeforeStart: boolean }

export function documentForm(document?: TrainingDocument): DocumentForm {
  return { title: document?.title ?? '', sessionId: document?.sessionId ?? '', requiredBeforeStart: document?.requiredBeforeStart ?? false }
}

/** Le titre proposé pour un fichier choisi : son nom, sans l'extension. */
export function titleFromFileName(fileName: string): string {
  return fileName.replace(/\.pdf$/i, '').replace(/[_-]+/g, ' ').trim()
}
